import Link from "next/link";
export function DownloadFile({ file, label = "Download" }) {
  if (!file) return null;

  return (
    <Link
      target="_blank"
      href={file.permalink}
      variant="outline"
      size="sm"
      className="z-50 px-3 py-1 text-sm font-button font-semibold transition-all duration-300 bg-brand-wool border-2 rounded-lg shadow-md lg:hover:bg-button lg:hover:text-button-foreground top-2 left-2"
    >
      {label}
    </Link>
  );
}
